import 'altcha';
import 'altcha/dist/i18n/pt-br.js';

import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';

export const AltchaWidget = forwardRef(({ onPayloadChange, onVerifyingChange }, ref) => {
  const widgetRef = useRef(null);

  useImperativeHandle(ref, () => ({
    reset: () => {
      if (widgetRef.current) widgetRef.current.reset();
      onPayloadChange(null);
    },
    verify: async () => {
      const widget = widgetRef.current;
      if (!widget) return null;

      widget.show();
      const result = await widget.verify();
      return (result && result.payload) || null;
    },
  }));

  useEffect(() => {
    const widget = widgetRef.current;
    if (!widget) return;

    const handleStateChange = (ev) => {
      const { state, payload } = ev.detail;

      onPayloadChange(state === 'verified' && payload ? payload : null);
      if (onVerifyingChange) onVerifyingChange(state === 'verifying');
    };

    widget.addEventListener('statechange', handleStateChange);
    return () => widget.removeEventListener('statechange', handleStateChange);
  }, [onPayloadChange, onVerifyingChange]);

  return (
    <altcha-widget
      ref={widgetRef}
      challenge={process.env.REACT_APP_ALTCHA_CHALLENGE_URL}
      language="pt-br"
      display="bar"
      configuration={JSON.stringify({
        minDuration: 500,
      })}
    ></altcha-widget>
  );
});



// WEBPACK FOOTER //
// ./src/components/Altcha/index.jsx